import React from 'react';
import { CatalogImage } from '../script/catalog-section';

const getCatalogText = (image: CatalogImage, lang: string): string => {
    const t = image.catalogImageText;
    if (!t) return '';
    if (typeof t === 'string') return t;
    return (lang === 'en' ? t.en : t.pt) || t.pt || '';
};

const renderCatalogText = (markedText: string): React.ReactNode => {
    if (!markedText) return null;
    const parts = markedText.split(/(<r>.*?<\/r>)/g);
    return parts.map((part, i) => {
        const match = part.match(/^<r>(.*)<\/r>$/);
        if (match) {
            return <span key={i} style={{ color: '#ea2127' }}>{match[1]}</span>;
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
    });
};

interface CatalogPreviewModalProps {
    isOpen: boolean;
    currentPage: number;
    catalogImages: CatalogImage[];
    language: string;
    onClose: () => void;
    onPageChange: (direction: number) => void;
}

const CatalogPreviewModal: React.FC<CatalogPreviewModalProps> = ({
    isOpen,
    currentPage,
    catalogImages,
    language,
    onClose,
    onPageChange
}) => {
    if (!isOpen) return null;

    const modalImage = catalogImages[currentPage] || null;

    return (
        <div 
            id="catalogModal" 
            className="modal" 
            style={{ 
                position: 'fixed', 
                zIndex: 9999, 
                left: 0, 
                top: 0, 
                width: '100%', 
                height: '100%', 
                backgroundColor: 'rgba(0,0,0,0.95)', 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <span 
                className="close" 
                onClick={onClose}
                style={{ 
                    position: 'fixed', 
                    top: '20px', 
                    right: '30px', 
                    fontSize: '45px', 
                    fontWeight: 'bold', 
                    cursor: 'pointer', 
                    color: '#fff', 
                    zIndex: 10001,
                    transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#ea2127'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#fff'}
            >
                &times;
            </span>
            
            <div className="catalog-preview-container" style={{ 
                position: 'relative', 
                margin: '0 auto', 
                maxWidth: '1200px',
                width: '100%'
            }}>
                <div className="catalog-preview-navigation">
                    <button 
                        className="catalog-preview-nav-btn catalog-preview-nav-prev" 
                        onClick={() => onPageChange(-1)}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button>
                    <button 
                        className="catalog-preview-nav-btn catalog-preview-nav-next" 
                        onClick={() => onPageChange(1)}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </div>
                <div className="catalog-preview-item">
                    {modalImage ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {getCatalogText(modalImage, language) && (
                                <h3 style={{
                                    margin: '0 0 15px 0',
                                    color: '#fff',
                                    fontSize: '32px',
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    lineHeight: '1.2em',
                                    pointerEvents: 'none'
                                }}>
                                    {renderCatalogText(getCatalogText(modalImage, language))}
                                </h3>
                            )}
                            <img
                                id="catalogPreviewImage"
                                src={modalImage.catalogImageUrl}
                                alt={modalImage.catalogImageName || 'Catalog Preview'}
                                style={{
                                    width: '100%',
                                    maxHeight: getCatalogText(modalImage, language) ? '82vh' : '90vh',
                                    objectFit: 'contain',
                                    borderRadius: '8px'
                                }}
                            />
                        </div>
                    ) : (
                        <div style={{ 
                            width: '100%', 
                            height: '90vh', 
                            backgroundColor: 'rgba(255,255,255,0.1)', 
                            borderRadius: '8px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            color: '#fff'
                        }}>
                            <p>No image available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CatalogPreviewModal;

